export default {
  state: {
    navTree:[]
  },
  getters: {

  },
  mutations: {
    setNavTree(state, navTree){
      state.navTree = navTree
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js